import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceRequestDtoModel } from '@heitown/common-dto';

import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class ServiceRequestApiClient extends BaseCRUDApiClient<ServiceRequestDtoModel> {
  baseUrl = this.config.apiEndpoint + '/service-request';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
